// extracted by mini-css-extract-plugin
export default {"container":"EditUserForm_container__ZGitH","images":"EditUserForm_images__s-qgD"};